import React, { useContext, createContext, } from 'react';
const defaultFlags = {
    usePendingStatus: false,
    useRemoteSubmissions: false,
};
const FeatureFlagContext = createContext(defaultFlags);
export const FeatureFlagProvider = ({ children, flags, }) => (React.createElement(FeatureFlagContext.Provider, { value: flags }, children));
export const useFeatureFlags = () => useContext(FeatureFlagContext);
